module.exports = __webpack_public_path__ + "static/media/account-feature-feedback.7b510b3d.png";